import i18next from 'i18next';
import { locales } from 'configs/i18n';

/* ------------------------------------- English ------------------------------------- */

i18next.addResources(locales.EN, 'BLOG_VIEW', {
  TITLE: 'Blog',
  EXPLORE_MORE_CONTENT_TITLE: 'Explore more content',
});

/* ------------------------------------- Spanish ------------------------------------- */

i18next.addResources(locales.ES, 'BLOG_VIEW', {
  TITLE: 'Blog',
  EXPLORE_MORE_CONTENT_TITLE: 'Explorar más contenido',
});
